import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../auth/auth.guard';
import { INRComponent } from './pages/inr/inr.component';
import { INRPatientProfileComponent } from './pages/inr-patient-profile/inr-patient-profile.component';
import { InrPatientListComponent } from './pages/inr-patients-list/inr-patients-list.component';

const routes: Routes = [
  {
    path: 'inr',
    component: INRComponent,
    canActivate: [ AuthGuard ],

    children: [
      {
        path: '',
        redirectTo: 'patients-list',
        pathMatch: 'full'
      },
      {
        path: 'patients-list',
        component: InrPatientListComponent,
      },
      {
        path: 'patients-list/:id',
        component: INRPatientProfileComponent,
      }
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
})
export class INRRouterModule { }
